import React from 'react';
import { Menu, MenuItem, ProSidebar, SidebarContent, SidebarHeader, SubMenu } from 'react-pro-sidebar';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { IMAGES } from 'src/appConfig/images';
import { isActive, SidebarMenu } from 'src/appConfig/sidebar';
import { IAppState } from 'src/store';
import { Image } from '../common';
import './styles.scss';


// More info: https://www.npmjs.com/package/react-pro-sidebar
const Sidebar: React.FC<Props> = ({ showSidebar, collapseSidebar, userPermissions }) => {
  if (!showSidebar) return null;
  const showLogo = !collapseSidebar;

  return (
    <ProSidebar className="cmp-sidebar" collapsed={collapseSidebar}>
      {showLogo && (
        <SidebarHeader className="cmp-sidebar__header">
          <Image src={IMAGES.logoFullText} className="cmp-sidebar__image--header" />
        </SidebarHeader>
      )}
      <SidebarContent>
        <Menu iconShape="circle">
          {SidebarMenu.map(x => {
            if (x.subMenu) {
              return (
                <SubMenu
                  key={x.title}
                  title={String(x.title).toUpperCase()}
                  icon={x.icon}
                  className="cmp-sidebar__subMenu">
                  {x.subMenu.map(y => (
                    <MenuItem key={y.title} active={isActive(y.href)}>
                      {String(y.title).toUpperCase()}
                      <Link to={y.href} />
                    </MenuItem>
                  ))}
                </SubMenu>
              );
            } else {
              return (
                <MenuItem
                  className="cmp-sidebar__menu"
                  key={x.title}
                  icon={x.icon}
                  active={(x.href && isActive(x.href)) || false}>
                  {String(x.title).toUpperCase()}
                  {x.href && <Link to={x.href} />}
                </MenuItem>
              );
            }
          })}
        </Menu>
      </SidebarContent>
    </ProSidebar>
  );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;
const mapStateToProps = (state: IAppState) => ({
  userPermissions: state.auth.permissions,
  showSidebar: state.common.showSidebar,
  collapseSidebar: state.common.collapseSidebar,
});

const mapDispatchToProps = {};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Sidebar));
